import lozad from 'lozad';

export function lazyLoading() {
    lozad('.lozad', {
        load: function(el) {
            el.srcset = el.dataset.srcset;
            el.src = el.dataset.src;
            el.onload = function() {
                el.classList.add('fade')
            }
        }
    }).observe()
    
    // Initialize library
    lozad('.lozad.smallcover', {
        load: function(el) {
            el.src = el.dataset.src;
            el.onload = function() {
                el.classList.add('fade')
            }
        }
    }).observe()
}